/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryKey =
  (
    courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsPathParams["courseRegistrationId"],
  ) =>
    [
      {
        url: "/api/v1/courseregistration/enrollment/:courseRegistrationId/management-tabs",
        params: { courseRegistrationId: courseRegistrationId },
      },
    ] as const;

export type GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryKey
  >;

export function getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryOptions(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryKey(
      courseRegistrationId,
    );
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs500
    >,
    GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs(
        courseRegistrationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna quais abas do painel de gerenciamento devem ser exibidas para o usuário autenticado com base no perfil (polo ou não) e nas características da matrícula: existência de monografia, bolsa e processo seletivo. **(Requer Authorization para autenticação)**
 * @summary Retorna as abas visíveis do gerenciamento de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/management-tabs}
 */
export function useGetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs<
  TData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponse,
  TQueryData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryKey,
>(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsPathParams["courseRegistrationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs400
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs401
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryKey(
      courseRegistrationId,
    );

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryOptions(
        courseRegistrationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
